import { mapKeys, mapValues, kebabCase } from 'lodash';

import Bridge from '../../Bridge';

export default function (url) {
  let colors = Bridge.get('context.colour', {});

  colors = mapKeys(colors, (value, key) => kebabCase(key));
  colors = mapValues(colors, value => (
    value ? `#${value}` : null
  ));

  return {
    url,
    variables: colors,
  };
}



// WEBPACK FOOTER //
// ./src/UI/presets/colors.js